import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
const Surface = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { tag = 'div', type, className } = _param, rest = _object_without_properties(_param, [
        "tag",
        "type",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(ThemeOverride, _object_spread({
        ref: ref,
        tag: tag,
        themeSurface: type,
        className: c(`ds-${type}`, className)
    }, rest));
});
Surface.displayName = 'Surface';
export default Surface;

//# sourceMappingURL=Surface.js.map